export const NAMESPACE = 'apiState'
